'use client';

import { c as _c } from "react/compiler-runtime";
import { BuilderBlocks } from '@builder.io/react';
import { mediaCardDefaults } from '@src/components/MediaCard/MediaCard.defaults';
import { VideoPlayer } from '@src/components/VideoPlayer/VideoPlayer';
import { useBreakpoints } from '@src/utils/breakpoints.util';
import { getBuilderPreviewMode } from '@src/utils/builder.util';
import { cn } from '@src/utils/tailwind';
import { LocalizedLink } from '../LocalizedLink/LocalizedLink';
import { type MediaCardProps } from './MediaCard.props';
export const MediaCard = t0 => {
  const $ = _c(46);
  const props = t0 === undefined ? mediaCardDefaults : t0;
  const {
    isMobile,
    isTablet
  } = useBreakpoints();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getBuilderPreviewMode();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    edit
  } = t1;
  let t2;
  if ($[1] !== isMobile || $[2] !== isTablet) {
    t2 = function getProp(prop, mobileProp) {
      return isMobile || isTablet ? mobileProp || prop : prop;
    };
    $[1] = isMobile;
    $[2] = isTablet;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getProp = t2;
  const {
    desktopImgSrc,
    mobileImgSrc,
    mediaType,
    brightcoveVideoId,
    videoPlayerAspectRatio,
    playAsPopup,
    desktopHeight,
    mobileHeight,
    redirectUrl,
    showGradient,
    innerPadding,
    builderBlock,
    children
  } = props;
  const Wrapper = redirectUrl ? LocalizedLink : "div";
  let t3;
  if ($[4] !== desktopImgSrc || $[5] !== getProp || $[6] !== mobileImgSrc) {
    t3 = getProp(desktopImgSrc, mobileImgSrc);
    $[4] = desktopImgSrc;
    $[5] = getProp;
    $[6] = mobileImgSrc;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const photoUrl = t3;
  let t4;
  if ($[8] !== desktopHeight || $[9] !== getProp || $[10] !== mobileHeight) {
    t4 = getProp(desktopHeight, mobileHeight);
    $[8] = desktopHeight;
    $[9] = getProp;
    $[10] = mobileHeight;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const photoSize = t4;
  const isMediaVideo = mediaType === "video";
  if (isMediaVideo && brightcoveVideoId) {
    let t5;
    if ($[12] !== brightcoveVideoId || $[13] !== playAsPopup || $[14] !== videoPlayerAspectRatio) {
      t5 = <VideoPlayer videoId={brightcoveVideoId} videoPlayerAspectRatio={videoPlayerAspectRatio} autoplay={false} playAsPopup={playAsPopup} />;
      $[12] = brightcoveVideoId;
      $[13] = playAsPopup;
      $[14] = videoPlayerAspectRatio;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    let t6;
    if ($[16] !== innerPadding || $[17] !== showGradient) {
      t6 = cn("absolute inset-0 flex flex-col items-center justify-end rounded-[30px]", {
        "pointer-events-none": !edit
      }, {
        "px-4 py-6": innerPadding === "small"
      }, {
        "lg:p-16 px-4 py-8": innerPadding === "large"
      }, {
        "bg-[linear-gradient(180deg,rgba(0,0,0,0)_52.41%,#161819_100%)]": showGradient
      });
      $[16] = innerPadding;
      $[17] = showGradient;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    const t7 = builderBlock?.id;
    let t8;
    if ($[19] !== children || $[20] !== t7) {
      t8 = <BuilderBlocks parentElementId={t7} dataPath="component.options.children" blocks={children} className="size-full" />;
      $[19] = children;
      $[20] = t7;
      $[21] = t8;
    } else {
      t8 = $[21];
    }
    let t9;
    if ($[22] !== t6 || $[23] !== t8) {
      t9 = <div className={t6}>{t8}</div>;
      $[22] = t6;
      $[23] = t8;
      $[24] = t9;
    } else {
      t9 = $[24];
    }
    let t10;
    if ($[25] !== t5 || $[26] !== t9) {
      t10 = <div className="relative">{t5}{t9}</div>;
      $[25] = t5;
      $[26] = t9;
      $[27] = t10;
    } else {
      t10 = $[27];
    }
    return t10;
  }
  let t5;
  if ($[28] !== innerPadding) {
    t5 = cn("flex flex-col rounded-[30px] bg-cover bg-center bg-no-repeat", {
      "px-4 py-6": innerPadding === "small"
    }, {
      "lg:p-16 px-4 py-8": innerPadding === "large"
    });
    $[28] = innerPadding;
    $[29] = t5;
  } else {
    t5 = $[29];
  }
  const t6 = `${showGradient ? "linear-gradient(180deg, rgba(0,0,0,0) 52.41%, #000000 100%), " : ""}url(${photoUrl})`;
  const t7 = photoSize ?? "auto";
  let t8;
  if ($[30] !== t6 || $[31] !== t7) {
    t8 = {
      backgroundImage: t6,
      height: t7
    };
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  const t9 = redirectUrl ?? "";
  let t10;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = cn("mt-auto", {
      "pointer-events-none": !edit
    });
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  const t11 = builderBlock?.id;
  let t12;
  if ($[34] !== children || $[35] !== t11) {
    t12 = <BuilderBlocks parentElementId={t11} dataPath="component.options.children" blocks={children} className="size-full" />;
    $[34] = children;
    $[35] = t11;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] !== t10 || $[38] !== t12) {
    t13 = <div className={t10}>{t12}</div>;
    $[37] = t10;
    $[38] = t12;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  let t14;
  if ($[40] !== Wrapper || $[41] !== t13 || $[42] !== t5 || $[43] !== t8 || $[44] !== t9) {
    t14 = <Wrapper className={t5} style={t8} href={t9}>{t13}</Wrapper>;
    $[40] = Wrapper;
    $[41] = t13;
    $[42] = t5;
    $[43] = t8;
    $[44] = t9;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  return t14;
};